import { connect } from 'react-redux'
import { Component } from "react"
import * as THREE from 'three';
import {isMobile} from 'react-device-detect';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import * as SkeletonUtils from 'three/addons/utils/SkeletonUtils.js';
import {
  Button,
  LoadingOverlay,
  Modal,
  ScrollArea,
  Accordion,
  Drawer,
  TextInput,
  ActionIcon,
  Divider,
  CloseButton,
  Stack,
  Paper, Flex, Group
} from "@mantine/core";
import {IconPlayerPlayFilled, IconPlayerStopFilled, IconBorderCorners, IconFileDescription} from '@tabler/icons-react';
import { v4 as uuidv4 } from 'uuid';
import{ onEditMode, onDetailObject3D } from "../../actions" 
import{getBoundingRec} from "../../game/help"


let objectMaxX = 350
let objectMaxY = 350
if(isMobile){
    objectMaxX = 250
    objectMaxY = 300
}

let mouse_mv_rebond = undefined
let mouse_up_rebond = undefined
let load_rebond = undefined
let editor_mode_rebond  = undefined
const distBoxMouse = 5


const pathContext = {
    scene3D: null,
    elements: {},
    accordion:{
        type: "",
        element_index: -1
    },
    zoom: 16,
    mode: "edit",
    last_version: 0,
    last_mouse: null,
    version: 0,
    loading: false,
    objectsScene: [],
    mouseBox: new THREE.Mesh(new THREE.SphereGeometry(distBoxMouse, 32, 16), new THREE.MeshPhongMaterial( {color: 0x00FFFF, transparent: true, opacity: 0.4} )),
    currentObject: null,
    currentDetail: null,
    toSave: false
}

class Listing3DElements extends Component{
  constructor(props) {
      super(props)
      pathContext.scene3D = this.getRendrerObject()
      this.state = pathContext
  }

  makeStateCopy(){
    return {
        scene3D: this.state.scene3D,
        elements: this.state.elements,
        zoom: this.state.zoom,
        mode: this.state.mode,
        accordion: this.state.accordion,
        last_mouse: this.state.last_mouse,
        last_version: this.state.last_version,
        version: this.state.version + 1,
        loading: this.state.loading,
        rendrerer: this.state.rendrerer,
        objectsScene: this.state.objectsScene,
        mouseBox: this.state.mouseBox,
        currentObject: this.state.currentObject,
        currentDetail: this.state.currentDetail,
        toSave: this.state.toSave,   
    }
    }

  async componentDidMount() {
    
    this.props.notification.addNotification("mousemove", (type, msg, arg)=>{
        if(!mouse_mv_rebond){
            mouse_mv_rebond = setInterval(()=>{
            clearInterval(mouse_mv_rebond)
            mouse_mv_rebond = undefined
            this.onMouseMove(msg)
            }, 5)
        }
    })
    this.props.notification.addNotification("zoom", (type, msg, arg)=>{
        if(msg.container !== "map-world") return
        this.state.zoom = msg.zoom
        this.setState(this.state)
        if(this.state.currentObject && this.state.currentObject.element3D && this.state.currentObject.element3D.parameters){ 
            this.placeZoom(this.state.currentObject.gltf, this.state.currentObject.element3D.parameters.scale, msg.zoom)
            
        }
      })

    this.props.notification.addNotification("mouseup", (type, msg, arg)=>{
        if(!mouse_up_rebond){
            mouse_up_rebond = setInterval(()=>{
            clearInterval(mouse_up_rebond)
            mouse_up_rebond = undefined
            this.onMouseUp(msg)
            }, 5)
        }
    })

    this.props.notification.addNotification("EditorMode", (type, msg, arg)=>{
        if(!editor_mode_rebond){
          editor_mode_rebond = setInterval(()=>{
            clearInterval(editor_mode_rebond)
            editor_mode_rebond = undefined
            let state = this.makeStateCopy()
            state.mode = msg.value
            this.setState(state)
          }, 5)
        }
      })

    this.props.notification.addNotification("Scene3D", async (type, msg, arg)=>{
        if(msg.container !== "map-world") return
        if(!load_rebond){ 
            load_rebond = setInterval(async ()=>{
            clearInterval(load_rebond)
            let state = this.makeStateCopy()
            
            state.loading = true
            
            state.scene3D.word3D = arg

            state.loading = false
            this.setState(state)
            }, 50)
        }
    })
    this.props.notification.onNotification("Scene3DAsk")
    let state = this.makeStateCopy()
    try{ 
        state.elements = await this.load()
    }catch(e){
        state.elements = {}
    }
    this.setState(state)

  }

  async load() {
    const uri = "/get/listing3D"
    let state = this.makeStateCopy()
    state.loading = true
    this.setState(state)
    try{ 
        const response = await fetch(uri, {
            method: "GET",
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            }
        })
        if(response.status === 200) {
            let state = this.makeStateCopy()
            state.loading = false
            this.setState(state)
            return response.json();
        }
        else{
            return {}
        }
    }
    catch(e){
        return {}
    }
  }

  getRendrerObject(){
    const camera = new THREE.PerspectiveCamera( 30, 1, 0.01, 100 );
    camera.position.set(0,0,4)
    camera.lookAt(0,0,0)

    const scene = new THREE.Scene();

    let directionalLight = new THREE.DirectionalLight(0xffffff, 2);
    directionalLight.position.set(0, 0, -5);
    directionalLight.lookAt(0,0,0)
    scene.add(directionalLight);
    directionalLight = new THREE.DirectionalLight(0xffffff, 2);
    directionalLight.position.set(0, 0, 100);
    directionalLight.lookAt(0,0,0)
    scene.add(directionalLight);

    directionalLight = new THREE.DirectionalLight(0xffffff, 2);
    directionalLight.position.set(0, 100, 0);
    directionalLight.lookAt(0,0,0)
    scene.add(directionalLight);
    directionalLight = new THREE.DirectionalLight(0xffffff, 2);
    directionalLight.position.set(0, -100, 0);
    directionalLight.lookAt(0,0,0)
    scene.add(directionalLight);

    directionalLight = new THREE.DirectionalLight(0xffffff, 2);
    directionalLight.position.set(100, 0, 0);
    directionalLight.lookAt(0,0,0)
    scene.add(directionalLight);
    directionalLight = new THREE.DirectionalLight(0xffffff, 2);
    directionalLight.position.set(-100, 0, 0);
    directionalLight.lookAt(0,0,0)
    scene.add(directionalLight);


    const renderer = new THREE.WebGLRenderer( { antialias: true } );
    renderer.setSize( objectMaxX, objectMaxY );
    renderer.setClearColor( 0xffffff, 0 );

    const controls = new OrbitControls(camera, renderer.domElement)

    
    controls.addEventListener('change', ()=>{
        renderer.render( scene, camera );

        //console.log("controls.addEventListener", camera.position,camera.rotation)
        this.doUpdateControl(camera.position,camera.rotation)
    });

    controls.update();

    const timer = setInterval(()=>{
        renderer.render( scene, camera );
        controls.update()
        renderer.setAnimationLoop(() => {
            this.doAnimation()
        })
    }, 50)
    return {renderer: renderer, controls: controls, camera:camera, scene: scene, timer: timer}
  }

  doAnimation(){
   
    for(let key in this.state.elements){
        const objects = this.state.elements[key]
        for(let i=0; i < objects.length; i ++){
            const element3d = objects[i]
            if(element3d.animationControler){
                element3d.animationControler.mixer.update(1/120)
            }
        }

    }
  }

  doUpdateControl(position, rotation){
   
    for(let key in this.state.elements){
        const objects = this.state.elements[key]
        for(let i=0; i < objects.length; i ++){
            const element3d = objects[i]
            if(element3d.gltf){
                element3d.position = new THREE.Vector3(-position.x, -position.y, -position.z)
                element3d.rotation = {x: -rotation.x, y: -rotation.y, z: -rotation.z}

                    /*if(this.state.currentObject && this.state.currentObject.gltf){
                        this.state.currentObject.gltf.scene.rotateX(rotation.x )
                        this.state.currentObject.gltf.scene.rotateY(rotation.y)
                        this.state.currentObject.gltf.scene.rotateZ(rotation.z)
                    }*/
            }
        }

    }
  }

  stopAllAnimation(){
   
    for(let key in this.state.elements){
        const objects = this.state.elements[key]
        for(let i=0; i < objects.length; i ++){
            const element3d = objects[i]
            if(element3d.animationControler){
                element3d.animationControler.action.stop(1/120)
            }
        }

    }
  }

  clearScene(){
    for( var i = this.state.scene3D.scene.children.length - 1; i >= 0; i--) { 
        const obj = this.state.scene3D.scene.children[i];
        if(obj.type === "DirectionalLight") continue
        this.state.scene3D.scene.remove(obj); 
    }
  }

  renderScene(id, key, position){
    const element3d = this.state.elements[key][position]

    const loader = new GLTFLoader();
    const file = `/${element3d.filename}`
    this.clearScene()
    const div = document.getElementById(id)
    div.appendChild( this.state.scene3D.renderer.domElement );
    this.state.scene3D.controls.reset();

    if(!element3d.gltf){ 
        loader.load(file, (gltf) => {
            var bbox = new THREE.Box3().setFromObject(gltf.scene);
            let t = bbox.max.x
            if(t < bbox.max.y)
                t = bbox.max.y
            if(t < bbox.max.z)
                t = bbox.max.z
            
            if(t !== 0){ 
                t = 1/t
                
            }

            /*let box
            let boxSize = -100
            let boundingRects = []
            gltf.scene.traverse( function ( child ){
                if ( child.isMesh )
                {
                const b = new THREE.Box3().setFromObject(child);
                boundingRects.push(b)
                const s = b.getSize(new THREE.Vector3()).length();
                if(s > boxSize){
                    boxSize = s
                    box = b
                }
                
                }
            });

            if(box){
                gltf.scene.scale.set(1/boxSize, 1/boxSize, 1/boxSize)
                const v = box.getCenter(new THREE.Vector3())
                gltf.scene.position.set(-v.x/boxSize, -v.y/boxSize, -v.z/boxSize)
                this.state.scene3D.camera.position.set(0, 0, 2)
                gltf.boundings = {
                    boundingRects: boundingRects,
                    boundingRect: box
                } 
            }*/

            gltf.boundings = getBoundingRec(gltf.scene)
            element3d.gltf = gltf
            this.clearScene()
            this.state.scene3D.scene.add(gltf.scene);
            this.setState(this.state)
        }) 
    } else{
        this.state.scene3D.scene.add(element3d.gltf.scene);
        this.state.scene3D.camera.position.set(0, 0, 2)
    }
  }
  stopAnimation(element3d, animation){
    if(!animation) return 
    if(element3d.animationControler ){
        element3d.animationControler.action.stop()
        animation.playing = false
        this.setState(this.state)
    }
  }
  playAnimation(element3d, position, animation){
    this.stopAllAnimation()
    if(element3d.animationControler && element3d.animationControler.position !== position){
        this.stopAnimation(element3d)
        element3d.animationControler = null
    }
    if(!element3d.animationControler){

        const clip = THREE.AnimationClip.findByName( element3d.gltf.animations, animation.name )//
        const mixer = new THREE.AnimationMixer( element3d.gltf.scene );
        const action = mixer.clipAction( clip )

        element3d.animationControler = {
            position: position,
            action: action,
            mixer: mixer,
            clip: clip
        }
        action.play()
    } else {
        element3d.animationControler.action.play()
        
    }
    animation.playing = true
    this.setState(this.state)
  }

  updateCoordinate(state, msg){
    /*if(!state.scene3D || !state.scene3D.word3D || !state.scene3D.word3D.map) return
    const {x: x, y:y, z:z} = state.scene3D.word3D.map.getPosition3D(msg.lngLat)
    if(state.mouseBox){ 
        state.mouseBox.position.set(x, y, z)
    }*/
  }

  
  onMouseMove(msg){
    const state = this.makeStateCopy()
    if(!state.scene3D || !state.scene3D.word3D || !state.scene3D.word3D.map) return
    
    state.last_mouse = msg
    const {x: x, y:y, z:z} = state.scene3D.word3D.map.getPosition3D(msg.lngLat)
    if(state.currentObject){
        if(state.last_mouse){ 
            state.currentObject.gltf.scene.position.set(x, y, z)
        } else {
            state.currentObject.gltf.scene.position.set(0, 0, 0)
        }
    }

    this.updateCoordinate(state, msg)

    //(msg.lngLat)

    this.setState(state)
  }
  
  onMouseUp(msg){
    console.log("Listing3DElements.onMouseUp", msg)
    const state = this.makeStateCopy()

    //state.objectsScene.push(state.currentObject)

    if(state.scene3D && state.scene3D.word3D && state.currentObject){
        this.props.notification.onNotification("CreateElement3D", {element: state.currentObject}, {lngLat: msg.lngLat})
        state.scene3D.word3D.scene.remove(state.currentObject.gltf.scene)
        state.currentObject = null
    }
    
    this.updateCoordinate(state, msg)
    this.setState(state)
  }

  removeObjectToWorld(element3D){
    const state = this.makeStateCopy()
    element3D.addToWord= false

    if(state.scene3D && state.scene3D.word3D && state.currentObject){
        state.scene3D.word3D.scene.remove(state.currentObject.gltf.scene)
        state.currentObject = null
    }

    this.setState(state)
  }

  placeZoom(gltf, scale, z){
    if(!scale) return
    z = Math.floor(z)
    if(scale[z]){ 
      gltf.scene.scale.set(scale[z].x, scale[z].y, scale[z].z)
    }
    else{
        for(z; z < 20; z++){
          if(scale[z]){ 
            gltf.scene.scale.set(scale[z].x, scale[z].y, scale[z].z)
            break
          }
        }
    }
  }

  addObjectToWorld(element3D){
    const state = this.makeStateCopy()
    element3D.addToWord= true

    if(state.scene3D){

        if(state.scene3D && state.scene3D.word3D && state.currentObject){
            state.scene3D.word3D.scene.remove(state.currentObject.gltf.scene)
            state.currentObject = null
        }
        
        let clone = SkeletonUtils.clone(element3D.gltf.scene)
        const gltf = {
            animations: [...element3D.gltf.animations],
            scene: clone,
            boundings: element3D.gltf.boundings
        }
        state.currentObject = {
            element3D: element3D,
            gltf: gltf
        }
        
        state.currentObject.gltf.scene.scale.set(element3D.gltf.scene.scale.x * 100, element3D.gltf.scene.scale.y * 100, element3D.gltf.scene.scale.z * 100)

        if(state.currentObject && state.currentObject.element3D && state.currentObject.element3D.parameters){ 
            this.placeZoom(state.currentObject.gltf, state.currentObject.element3D.parameters.scale, state.zoom)

            if(state.currentObject.element3D.parameters.rotate){ 
                const r = state.currentObject.element3D.parameters.rotate
                state.currentObject.gltf.scene.rotation.set(r.x, r.y, r.z)
            }
            if(state.currentObject.element3D.parameters.y){ 
                state.currentObject.gltf.scene.position.set(state.currentObject.gltf.scene.position.x, state.currentObject.element3D.parameters.y, state.currentObject.gltf.scene.position.z)
            }
        }

        state.scene3D.word3D.scene.add(gltf.scene)
        this.setState(state)
    }

    
  }

  openObjectDetail(element3D){
    this.props.onDetailObject3D(element3D, this.state.scene3D.word3D.map.getCenter())
    //const state = this.makeStateCopy()
    //state.currentDetail = element3D
    //this.state.scene3D.word3D.map.getCenter()
    
    //this.setState(state)
  }
  render() {
    if(this.state.mode !== 'edit') return (
        <>
            
        </>
    )
    return (
    <>
        <Accordion className='accordion' value={this.state.accordion.type} onChange={(value)=>{
                                    const state = this.makeStateCopy()
                                    state.accordion.type = value
                                    this.setState(state)
                                }}>
            { 
                Object.keys(this.state.elements).map( (type, index) => (
                    <Accordion.Item key={index} value={type}>
                        <Accordion.Control>
                            <h2 >{type}</h2>
                        </Accordion.Control>
                        <Accordion.Panel>
                                <Accordion value={this.state.accordion.element_index} onChange={(value)=>{
                                                                        const state = this.makeStateCopy()
                                                                        state.accordion.element_index = value
                                                                        if(value){ 
                                                                            const params = value.split('-')
                                                                        if(params.length > 1){ 
                                                                            
                                                                            this.renderScene(`scene-${value}`, params[0], parseInt(params[1]))
                                                                        }
                                                                    }
                                                                    this.setState(state)}}>
                                {
                                    this.state.elements[type].map((element3D, position)=>(
                                        <Accordion.Item key={position} value={`${type}-${position}`}>
                                            <Accordion.Control>{element3D.nom}</Accordion.Control>
                                            <Accordion.Panel>
                                                
                                                <ScrollArea w={600}>Fichier: {element3D.filename.replace("game/datas/models/", "")}</ScrollArea>
                                                    <Flex
                                                        mih={50}
                                                        gap="md"
                                                        justify="flex-start"
                                                        align="center"
                                                        direction="row"
                                                        wrap="wrap"
                                                        >
                                                    {
                                                        element3D.gltf && element3D.gltf.animations && element3D.gltf.animations.length > 0 ? (
                                                            <Button onClick={(e)=>{
                                                                const state = this.makeStateCopy()
                                                                if(!element3D.animation.accordion) element3D.animation.accordion = {}
                                                                if(element3D.animation.accordion.visible) element3D.animation.accordion.visible = false
                                                                else element3D.animation.accordion.visible = true
                                                                this.setState(state)}}>{element3D.gltf.animations.length} animations</Button>
                                                        ):""
                                                    }
                                                    { 
                                                        element3D.gltf ? (
                                                            <Group>
                                                                <ActionIcon  onClick={()=>{
                                                                    this.openObjectDetail(element3D)
                                                                }}><IconFileDescription size={14} /></ActionIcon>
                                                                <ActionIcon className={element3D.addToWord? "blue":"default"} variant={element3D.addToWord?"":"default"}   onClick={()=>{
                                                                    
                                                                    if( element3D.addToWord)  {
                                                                        this.removeObjectToWorld(element3D)
                                                                    }
                                                                    else {
                                                                        
                                                                        this.addObjectToWorld(element3D)
                                                                    }
                                                                
                                                                }}><IconBorderCorners size={14} /></ActionIcon>
                                                                
                                                            </Group>
                                                            )
                                                            : ""
                                                    }
                                                </Flex>
                                                
                                                <div className={element3D.animation && element3D.animation.accordion && element3D.animation.accordion.visible===true?'animation visible':'animation'}>
                                                    <Accordion value={element3D.animation && element3D.animation.accordion? element3D.animation.accordion.element_index: 'animate-0'} 
                                                            onChange={(value)=>{
                                                                const state = this.makeStateCopy()
                                                                if(!element3D.animation.accordion) element3D.animation.accordion = {}
                                                                element3D.animation.accordion.element_index = value
                                                                this.setState(state)}}>
                                                    {
                                                        element3D.gltf && element3D.gltf.animations ? 
                                                            element3D.gltf.animations.map((animation, pos)=>(
                                                                        <Accordion.Item key={pos} value={`animate-${pos}`}>
                                                                            <Accordion.Control>
                                                                                <p>Animation {pos + 1} :  {animation.name} </p>
                                                                            </Accordion.Control>
                                                                            <Accordion.Panel>
                                                                                <Stack gap="md" style={{"fontSize": "1rem"}}>
                                                                                    <p>
                                                                                        <span>durée: {animation.duration.toFixed(3)}</span><span> | </span>
                                                                                        
                                                                                        <ActionIcon variant="filled" aria-label="Settings" onClick={()=>{
                                                                                            if(animation.playing === true) this.stopAnimation(element3D, animation)
                                                                                            else this.playAnimation(element3D, pos, animation)
                                                                                        }}>
                                                                                            {animation.playing === true? (<IconPlayerStopFilled size={14}/>) : (<IconPlayerPlayFilled size={14}/>)}
                                                                                            
                                                                                        </ActionIcon>
                                                                                    </p>
                                                                                </Stack>
                                                                            </Accordion.Panel>
                                                                        </Accordion.Item>
                                                                    
                                                            
                                                            ))
                                                        : ""
                                                    }
                                                    </Accordion>
                                                </div>
                                                <div id={`scene-${type}-${position}`} className="display-3d-content" style={{width: objectMaxX, height: objectMaxY}}>
                                                </div>
                                            </Accordion.Panel>
                                        </Accordion.Item>
                                    ))
                                }
                            </Accordion>
                        </Accordion.Panel>
                    </Accordion.Item>
                ))
            }
        </Accordion>
        
    </>)
  }

}

const mapDispatchToProps = {
  onEditMode: onEditMode,
  onDetailObject3D: onDetailObject3D
}

const mapStateToProps = (state) => {  
    return {
        editMode: state.editMode,
        notification: state.notification
    }
}


Listing3DElements = connect(mapStateToProps, mapDispatchToProps)(Listing3DElements);

export default Listing3DElements;
